export const PHONE_DISPLAY = '0176 55677271';
export const PHONE_HREF = 'tel:+4917655677271';
export const WHATSAPP_MESSAGE =
  'Hallo, ich brauche Hilfe beim Abschleppdienst in Berlin.';
export const WHATSAPP_HREF = `https://wa.me/4917655677271?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;
